import { render, staticRenderFns } from "./BusChangeViewDialog.vue?vue&type=template&id=289564bc&scoped=true&"
import script from "./BusChangeViewDialog.vue?vue&type=script&lang=js&"
export * from "./BusChangeViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusChangeViewDialog.vue?vue&type=style&index=0&id=289564bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289564bc",
  null
  
)

export default component.exports